<div class="viewport-1" [style.background-image]="'url(' + taskBackgroundImage + ')'">
  <student-header></student-header>
  <task-bar #taskBar [totalPoints]="totalTaskPoints"></task-bar>
    <div class="task-screen-element verify-the-blank-container"
      [style.background-image]="' ' + taskContainerColor + ' '"
      [class]="(animationComplete) ? 'taskShow' : 'taskHide'">
    <button class="replayVideo-no-timerbar" (click)="replayVideo()" [disabled]="disableVideo()">
    </button>
    <div class="word-to-verify">
      <button class="speaker" (click)="repeatWord()" [disabled]="disableAVButtons">
      </button>
      <div class="verify-word font-42">
        {{targetWord}}
      </div>
    </div>
    <div class="response-row">
      <button
          [class.verify-response-correct-grayed]="disableResponseButtons"
          [class.verify-response-correct]="!disableResponseButtons"
          [style.border-color]="' ' + highlightColor + ' '" [disabled]="disableResponseButtons" (click)="submitAnswer(true)"
      >
      </button>
      <button  class="next-trial-base"
          [class]="{'next-trial-hidden': hideNextButton || unmaskedTask, 'next-trial-grayed' : disableNextButton, 'next-trial' : !disableNextButton, 'toggle-next-on' : toggleNextButton}"
          [style]="{'border-color':' ' + highlightColor + ' ', 'position': 'relative ', 'top': '-40% '}"
          [disabled]="disableNextButton"
          (click)="nextTrial()">
      </button>
      <button [class]="(disableResponseButtons) ? 'verify-response-incorrect-grayed' : 'verify-response-incorrect'"
          [style.border-color]="' ' + highlightColor + ' '" [disabled]="disableResponseButtons" (click)="submitAnswer(false)">
      </button>
    </div>
  </div>
  <trial-counter [showCorrectIncorrect]="false" [taskAnimationComplete]="animationComplete"></trial-counter>
  <instructions [videoSource]="instructionalVideoFile"></instructions>
  <save-data-dialog (onSaveButtonClick)="saveTrialData()"></save-data-dialog>
</div>
